import React, { useState, useEffect } from "react"
import { CSSTransition, TransitionGroup } from "react-transition-group"
import styled from "styled-components"
import { email } from "@config"
import { navDelay, loaderDelay } from "@utils"
import { usePrefersReducedMotion } from "@hooks"

const StyledHeroSection = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;
  padding: 0;

  @media (max-width: 480px) and (min-height: 700px) {
    padding-bottom: 10vh;
  }

  h1 {
    margin: 0 0 32px 0;
    color: #05d9e8;
    font-family: poppins;
    font-size: clamp(14px, 5vw, 16px);
    font-weight: 400;
    @media (max-width: 480px) {
      margin: 0 0 20px 2px;
    }
  }

  h3 {
    margin-top: 8px;
    color: #ff2a6d;
    line-height: 0.9;
  }

  p {
    margin: 20px 0 0;
    max-width: 560px;
    color: #e4e2f3;
  }

  .email-link {
    margin-top: 48px;
    color: #d1f7ff;
    background-color: transparent;
    border: 1px solid #d1f7ff;
    border-radius: 4px;
    padding: 1.25rem 1.75rem;
    font-size: 16px;
    font-family: poppins;
    line-height: 1;
    text-decoration: none !important;
    cursor: pointer;
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
    &:hover,
    &:focus,
    &:active {
      background-color: rgba(100, 255, 218, 0.1);
      outline: none;
    }
    &:after {
      display: none !important;
    }
  }
`

const Hero = () => {
  const [isMounted, setIsMounted] = useState(false)
  const prefersReducedMotion = usePrefersReducedMotion()

  useEffect(() => {
    if (prefersReducedMotion) {
      return
    }

    const timeout = setTimeout(() => setIsMounted(true), navDelay)
    return () => clearTimeout(timeout)
  }, [])

  const one = <h1>Hi, my name is</h1>
  const two = <h2 className="big-heading">Noah Ben Aas.</h2>
  const three = <h3 className="medium-heading">I build things for the web.</h3>
  const four = (
    <div className="hero-title-description">
      <p>
        I'm a front-end developer that enjoys building digital
        products. My current focus is to pursue and establish myself in the web
        development industry, where I can us my skills, learn and create
        web-applications.
      </p>
    </div>
  )
  const five = (
    <a href={`mailto:${email}`} className="email-link">
      Get In Touch
    </a>
  )

  const items = [one, two, three, four, five]

  return (
    <StyledHeroSection>
      {prefersReducedMotion ? (
        <>
          {items.map((item, i) => (
            <div key={i}>{item}</div>
          ))}
        </>
      ) : (
        <TransitionGroup component={null}>
          {isMounted &&
            items.map((item, i) => (
              <CSSTransition key={i} classNames="fadeup" timeout={loaderDelay}>
                <div style={{ transitionDelay: `${i + 1}00ms` }}>{item}</div>
              </CSSTransition>
            ))}
        </TransitionGroup>
      )}
    </StyledHeroSection>
  )
}

export default Hero
